import {h, Fragment} from "preact"
import { HistoryElement } from "@nosto/preact"
import { useEffect } from "preact/hooks"

import { closeSearchOverlay } from "../helpers"
import { defaultConfig, popularSearches, DROPDOWN_RECID } from "../config"

export default function History() {

    useEffect(() => {
        if(typeof window.nostojs === 'function'){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .addElements([ DROPDOWN_RECID ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    const handleSearchClick = (e) => {
        if(e.target.closest('.ns-keyword')) {
            closeSearchOverlay();
        }
    }

    return (
        <div class="ns-autocomplete group overflow-y-auto group-open/results:block w-full bg-t-background">
            <div class="flex flex-col lg:group-[.is-desktop]/results:grid lg:group-[.is-desktop]/results:grid-cols-[200px_1fr] group-[.is-mobile]/results:gap-md lg:group-[.is-desktop]/results:gap-md">
                {/* queries / keywords */}
                <div>
                    <h2 
                        id="nosto-popular-searches" 
                        class="utility font-bold text-t-brand-secondary-contrast mb-sm lg:mb-md group-[.is-mobile]/results:px-sm"
                    >
                        Popular Search Terms
                    </h2>
                    <ul 
                        class="flex scrollbar-none flex-row scroll-smooth snap-mandatory mb-sm lg:mb-0 group-[.is-mobile]/results:px-sm group-[.is-mobile]/results:flex-nowrap group-[.is-mobile]/results:overflow-x-scroll group-[.is-desktop]/results:flex-col group-[.is-desktop]/results:overflow-x-hidden gap-2xs"
                        role="group"
                        aria-labelledby="nosto-popular-searches"
                    >
                        {popularSearches.slice(0, defaultConfig.historySize).map(item => (
                            <li 
                                key={item}
                                class="aria-selected:bg-p-light shrink-0" 
                                role="option"
                                aria-selected="false"
                                onClick={handleSearchClick}
                            >
                                <HistoryElement
                                    class="ns-keyword cursor-pointer body-14 font-medium text-t-brand-secondary-contrast group-[.is-mobile]/results:border group-[.is-mobile]/results:border-t-ui-lines-2 group-[.is-mobile]/results:p-xs"
                                    query={{ query: item }}
                                >
                                    {item}
                                </HistoryElement>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* rec / products */}
                <div 
                    class="nosto_element group-[.is-mobile]/results:px-sm" 
                    id={DROPDOWN_RECID} 
                />
            </div>
        </div>
    )
}
